import { render, staticRenderFns } from "./ChooseBoxModal.vue?vue&type=template&id=85ef4f4c&scoped=true&lang=pug&"
import script from "./ChooseBoxModal.vue?vue&type=script&lang=js&"
export * from "./ChooseBoxModal.vue?vue&type=script&lang=js&"
import style0 from "./ChooseBoxModal.vue?vue&type=style&index=0&id=85ef4f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ef4f4c",
  null
  
)

export default component.exports